import { render, staticRenderFns } from "./Network.vue?vue&type=template&id=8bd4d51a&scoped=true&"
import script from "./Network.vue?vue&type=script&lang=ts&"
export * from "./Network.vue?vue&type=script&lang=ts&"
import style0 from "./Network.vue?vue&type=style&index=0&id=8bd4d51a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd4d51a",
  null
  
)

export default component.exports